import { getGeneralImage, generateStyleClasses } from "../../helpers/commonFunctions";
import { HeaderDataType } from "../../interfaces/HeaderType";

const Header = ({ data }: { data: HeaderDataType }) => {
  return (
    <div className="vas-card vas-w-100" style={{ border: "0px" }}>
      <div
        className={`vas-align-self-start ${generateStyleClasses(data?.style)} vas-fs-5`}
      >
        {data?.icon && (
          <img
            className="vas vas-d-inline vas-mb-2"
            src={getGeneralImage(data?.icon)}
            alt="header_icon"
            height={36}
            width={36}
          />
        )}
        <span style={{ color: data?.textColor }}>{data?.text ?? ""}</span>
      </div>
    </div>
  );
};

export default Header;
